import type { EntityType } from "./global-map.types"

export const globalMapSliceName = "globalMap"

export const LA_FALLBACK = {
  latitude: 34.0522,
  longitude: -118.2437,
  zoom: 10
} as const

export const DEFAULT_LAYERS: EntityType[] = ["project", "lead"]

export const VIEWPORT_DEBOUNCE_MS = 350

// A pan is already debounced once, upstream inside `MapCanvas`, before it
// ever reaches `useMapFeatures` — this is the debounce for free-text search,
// which fires on every keystroke instead and needs its own, shorter-lived
// timer rather than sharing the pan's.
export const SEARCH_DEBOUNCE_MS = 300

// The List tab's page size, sent as `page_size` on every `fetchListRows`
// call — matches `GlobalMapListQuerySerializer`'s own backend default so a
// caller that never overrides it sees the same page the server would give
// it anyway. The backend's page-number pagination (2026-09-20, replacing
// cursor pagination) only accepts 5/10/20/50 — 25 (the old cursor-era
// default) would 400 on every real request.
export const LIST_PAGE_SIZE = 10

// The only page sizes the backend accepts (`LIST_PAGE_SIZE`'s own comment) —
// `ListPaginationFooter`'s size-changer options, `useGlobalMapUrlSync`'s
// `?pageSize=` validation, and `useListFeatures`'s persisted-preference
// validation all read off this one list rather than each hardcoding it.
export const VALID_LIST_PAGE_SIZES = [5, 10, 20, 50] as const

// The `ui-preferences` "table" this task's page-size preference is filed
// under (`patchListPageSize`/`selectTableTabPageSize`) — the List tab has no
// customizable columns of its own, so `"all"` is the only tab key it ever
// uses, standing in for "the whole List tab" rather than one of its
// All/Projects/Leads sub-tabs.
export const LIST_PREFS_TABLE_KEY = "global-map-list"
export const LIST_PREFS_TAB_KEY = "all"

// "Look Around a Zip Code" — the six fixed radius stops, matching
// `ezbuild_back`'s own `NEAR_RADIUS_CHOICES_MI` (serializers.py) exactly; the
// backend 400s on any other value, so this is a closed set kept in sync by
// hand, the same convention every other closed option list on this feature
// already follows.
export const NEAR_RADIUS_STOPS_MI = [0.5, 1, 5, 10, 20, 50] as const
